import { useContext } from "react";
import { createFailure, ensure, validationFailed, ValidationResult, validationSuccessful } from "sprint-common-web";

import { UpdateEpisodeRequest } from "../../../../api/UpdateEpisodeRequest";
import { useAssetsManageTvSeriesApi } from "../../../../api/useAssetsManageTvSeriesApi";
import { EpisodeDetails } from "../../../../TvSeriesDetails";
import { EpisodePageContext } from "../../context/EpisodePageProvider";
import { UpdatedEpisodeData } from "./EditEpisodeForm";
import { EditEpisodeFormInputs } from "./EditEpisodeFormInputs";

export const useEditEpisodeForm = () => {
    const { selectedEpisode, selectedTvSeries, selectedSeason } = useContext(EpisodePageContext);

    const { updateEpisode } = useAssetsManageTvSeriesApi();

    const editEpisode = async (inputs: EditEpisodeFormInputs): Promise<UpdatedEpisodeData> => {
        return updateEpisode(selectedEpisode.id, createRequest(selectedTvSeries.id, inputs)).then(() =>
            getUpdatedEpisodeData(inputs)
        );
    };

    const getUpdatedEpisodeData = (inputs: EditEpisodeFormInputs): UpdatedEpisodeData => {
        ensure(inputs.number);

        return {
            title: inputs.title,
            number: inputs.number,
            episodeId: selectedEpisode.id
        };
    };

    const isNewEpisodeTitleUnique = (title: string): ValidationResult => {
        const isUnique = !selectedSeason.episodes.some(
            (episode: EpisodeDetails) =>
                episode.title.toLowerCase() === title?.toLowerCase() && episode.id !== selectedEpisode.id
        );

        if (isUnique) {
            return validationSuccessful();
        }

        const failure = createFailure("Enter other Title because this is already taken", "episode.TitleAlreadyTaken");

        return validationFailed([failure]);
    };

    const isNewEpisodeNumberUnique = (number: number): ValidationResult => {
        const isUnique = !selectedSeason.episodes.some(
            (episode: EpisodeDetails) =>
                episode.number === number && selectedEpisode.id !== episode.id && !episode.mergedTargetId
        );
        if (isUnique) {
            return validationSuccessful();
        }

        const failure = createFailure(
            "Enter other episode number because this is already taken",
            "episode.NumberAlreadyTaken"
        );

        return validationFailed([failure]);
    };

    return {
        selectedEpisode,
        editEpisode,
        isNewEpisodeTitleUnique,
        isNewEpisodeNumberUnique
    };
};

const createRequest = (tvSeriesId: string, inputs: EditEpisodeFormInputs): UpdateEpisodeRequest => {
    ensure(inputs.number);

    return {
        tvSeriesId: tvSeriesId,
        title: inputs.title,
        episodeNumber: inputs.number
    };
};
